module.exports = __webpack_public_path__ + "media/images/emblems/Eggersri-2de2cef4f137cbc421e9c78f8354b95b.png";